import { Menubar } from "primereact/menubar";
import { useNavigate, useLocation } from "react-router-dom";


export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToId = (id: string) => {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50); // 延迟，确保页面渲染完成
  };

  const items = [
    {
      label: "Home",
      command: () => {
        if (location.pathname !== "/") navigate("/"); // 如果不在首页先跳回
        scrollToId("slogan");
      },
    },
    {
      label: "Advantage",
      command: () => {
        if (location.pathname !== "/") navigate("/"); // 如果不在首页先跳回
        scrollToId("advantage");
      },
    },
    {
      label: "Exploration",
      command: () => {
        if (location.pathname !== "/") navigate("/");
        scrollToId("capabilities");
      },
    },
    {
      label: "Training",
      command: () => {
        if (location.pathname !== "/") navigate("/");
        scrollToId("training");
      },
    },
    {
      label: "Benchmarks",
      command: () => {
        if (location.pathname !== "/") navigate("/");
        scrollToId("benchmarks");
      },
    },
    // {
    //   label: "Application Scenarios",
    //   command: () => {
    //     if (location.pathname !== "/") navigate("/");
    //     scrollToId("application");
    //   },
    // },
    {
      label: "Plans",
      command: () => {
        if (location.pathname !== "/") navigate("/");
        scrollToId("products");
      },
    },
    {
      label: "Download",
      command: () => {
        if (location.pathname !== "/") navigate("/");
        scrollToId("download");
      },
    },
    // {
    //   label: "Feedback",
    //   command: () => navigate("/contact"),
    // },
  ];
  // 1. 在这里定义你的 Logo 组件
  // const logo = (
  //   <div 
  //     className="flex align-items-center cursor-pointer mr-4" 
  //     onClick={() => scrollToId("slogan")} // 点击 Logo 回到首页
  //     style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginRight: '1rem' }}
  //   >
  //     <img 
  //       alt="Logo" 
  //       src="/icon.png" // 确保你的 logo 图片放在 public 文件夹下
  //       height="40" 
  //       className="mr-2" 
  //     />
  //     <span style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>TabDSL</span>
  //   </div>
  // );
  return (
    <Menubar
      model={items}
      start={
        <span
          className="logo-text"
          style={{
            color: "var(--base-accent)",
            fontWeight: 900,
            letterSpacing: "-1.5px",
          }}
        >
          Tab
          <span
            style={{
              fontWeight: 300,
              opacity: 0.7,
            }}
          >
            DSL
          </span>
    
          <span
            style={{
              marginLeft: "6px",
              padding: "2px 8px",
              borderRadius: "999px",
              background: "var(--base-accent)",
              color: "#fff",
              fontSize: "0.72rem",
              fontWeight: 700,
              lineHeight: 1.4,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            AI
          </span>
        </span>
      }
      style={{ position: "sticky", top: 0, zIndex: 1000 }}
    />
  );
}
